module.exports = __webpack_public_path__ + "static/media/foosball.26e69ef9.png";